import { enqueueSnackbar } from "notistack";
import {
  DELETE_DRIVER_REQUEST,
  GET_LIST_DRIVER,
  GET_LIST_DRIVER_REQUEST,
  INVITE_DRIVER_FAILURE,
  INVITE_DRIVER_REQUEST,
  INVITE_DRIVER_SUCCESS,
} from "../constants";
import {
  deleteAuthenticationRequest,
  getRequest,
  getRequestAuthenticationRequest,
  postAuthenticationRequest,
} from "../../../services/apiManager/apiRequests";
import apiConfig from "../../../services/apiManager/apiConfig";
import { DRIVER_GET_STATE_DATA } from "../constants";
import axios from "axios";
import { generateUUID, getDeviceName } from "../../../utils";
import storePersist, { localConstant } from "../../../services/localStorage";
import SnackbarConfig from "../../../utils/snackbarConfig";

export const inviteDriverRequest =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: INVITE_DRIVER_REQUEST,
        payload: { isLoading: true },
      });
      const response = await postAuthenticationRequest(
        apiConfig.inviteDriver,
        params,
        null,
        "application/json",
        "application/json",
      );
      if (response?.status === "ACCEPTED") {
        dispatch({
          type: INVITE_DRIVER_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: INVITE_DRIVER_FAILURE,
          payload: { isLoading: false },
        });
        callback(response);
      }
      dispatch({
        type: INVITE_DRIVER_FAILURE,
        payload: { isLoading: false },
      });
    } catch (error) {
      callback(error);
      dispatch({
        type: INVITE_DRIVER_FAILURE,
        payload: { isLoading: false },
      });
    }
  };

export const getDriverListRequest =
  (userId, callback = () => {}) =>
  async (dispatch) => {
    const apiUrl = `${apiConfig.getDriverList}/${userId}`;
    try {
      dispatch({
        type: GET_LIST_DRIVER_REQUEST,
        payload: true,
      });
      const response = await getRequestAuthenticationRequest(apiUrl, {});
      if (response) {
        dispatch({
          type: GET_LIST_DRIVER,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: GET_LIST_DRIVER_REQUEST,
          payload: false,
        });
        callback({});
      }
    } catch (error) {
      enqueueSnackbar("Failed to fetch drivers", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      dispatch({
        type: GET_LIST_DRIVER_REQUEST,
        payload: false,
      });
      callback({});
    }
  };

export const deleteDriverRequest =
  (userId, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: DELETE_DRIVER_REQUEST,
        payload: true,
      });
      const apiUrl = `${apiConfig.deleteDriver}/${userId}`;
      const response = await deleteAuthenticationRequest(apiUrl, {});
      if (response) {
        dispatch({
          type: DELETE_DRIVER_REQUEST,
          payload: false,
        });
        callback(response);
      } else {
        dispatch({
          type: DELETE_DRIVER_REQUEST,
          payload: false,
        });
        callback({});
      }
    } catch (error) {
      enqueueSnackbar("Failed to delete driver", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      dispatch({
        type: DELETE_DRIVER_REQUEST,
        payload: false,
      });
      callback({});
    }
  };

export const updateDriverRequest =
  (userId, data, uploadedFile, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: DELETE_DRIVER_REQUEST,
        payload: true,
      });
      const apiUrl = `${apiConfig.updateDriver}/${userId}`;
      const formData = new FormData();
      formData.append(
        "preValidatedMetadata",
        JSON.stringify({
          visibility: "PRIVATE",
          lifespan: "PERMANENT",
        }),
      );
      const mediaInfosArray = [];
      for (let index = 0; index < data?.fileInfosArray?.length; index++) {
        const file = data?.fileInfosArray[index];
        const obj = {
          name: file.name,
          mediaType: file.mediaType,
          mediaCode: file.mediaCode,
        };
        mediaInfosArray.push(obj);
        formData.append(file.name, file.mediaObj);
      }
      formData.append("fileInfos", JSON.stringify(mediaInfosArray));
      formData.append("updateFiles", data?.deleteOldMedia);
      formData.append("uploadType", "DOCUMENT");
      formData.append("entityType", "SAFE_TRUCK_PARKING");

      const userJson = {
        firstName: data.firstName,
        lastName: data.lastName,
        middleName: data.middleName,
        fullName: "",
        addressLine1: data.addressLine1,
        city: data.city,
        stateCode: data.stateCode,
        countryCode: "+1",
        postalCode: data.postalCode,
        phone: data?.phone,
      };
      const userBlob = new Blob([JSON.stringify(userJson)], {
        type: "application/json",
      });
      formData.append("user", userBlob);
      axios({
        method: "put",
        url: apiUrl,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          country: "USA",
          source: getDeviceName(),
          correlationId: generateUUID(),
          Authorization: `Bearer ${storePersist.get(
            localConstant.API_ACCESS_TOKEN,
          )}`,
        },
      })
        .then(function (response) {
          if (
            response?.data?.statusCode >= 200 &&
            response?.data?.statusCode < 300
          ) {
            dispatch({
              type: DELETE_DRIVER_REQUEST,
              payload: response.data,
            });
            callback(response);
            enqueueSnackbar(response?.data?.message, {
              variant: "success",
              autoHideDuration: 3000,
              action: SnackbarConfig,
            });
          } else {
            enqueueSnackbar("Error updating driver", {
              variant: "error",
              autoHideDuration: 3000,
              action: SnackbarConfig,
            });
            dispatch({
              type: DELETE_DRIVER_REQUEST,
              payload: response,
            });
            callback(response);
          }
        })
        .catch(function (response) {
          enqueueSnackbar("Error updating driver", {
            variant: "error",
            autoHideDuration: 3000,
            action: SnackbarConfig,
          });
          callback(response);
        });
    } catch (error) {
      enqueueSnackbar("Error updating driver", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      dispatch({
        type: DELETE_DRIVER_REQUEST,
        payload: false,
      });
      callback({});
    }
  };

export const stateListDriverRequest =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      const response = await getRequest(apiConfig.getStateList, params);
      if (response?.resultObject) {
        dispatch({
          type: DRIVER_GET_STATE_DATA,
          payload: response?.resultObject,
        });
        callback(response);
      } else {
        callback({});
      }
    } catch (error) {
      enqueueSnackbar("Failed to fetch state list for drivers", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
    }
  };
